// extracted by css-extract-rspack-plugin
export default {"btnChoose":"fyrj9","tableFile":"ka7M8","button--choose":"dEvFm","submitButton":"RsXIX"};